import React, {
  useState, Suspense, lazy
} from 'react';
import styled from 'styled-components';
import renderMobileShopOptions from '../renderMobileShopOptions';
import CloseIcon from './CloseIcon';
import ShopIcon from './ShopIcon';

const OffCanvas = lazy(() => import('react-aria-offcanvas'));

interface OwnProps {
  fields: any;
  searchSuggestions: JSX.Element;
}

const StyledShopMenu = styled.div`
  display: none;
  @media (max-width: 992px) {
    display: block;
    order: 3;
    margin-top: 2px;
    cursor: pointer;
  }
`;

const ShopMenu = ({
  fields, searchSuggestions,
}: OwnProps) => {
  const isSSR = typeof window === 'undefined';
  const [shopMenu, showShopMenu] = useState(false);

  return (
    <StyledShopMenu>
      <ShopIcon
        onClickCallbackShopMenu={() => showShopMenu(!shopMenu)}
        aria-label="Shop Sezzle Stores"
      />
      {!isSSR && (
        <Suspense fallback={<div />}>
          <OffCanvas
            isOpen={shopMenu}
            onClose={() => showShopMenu(false)}
            height="100%"
            width="70vw"
            position="right"
            style={
              {
                overlay: { zIndex: '1000' },
                content: {
                  background: '#ffffff',
                  overflow: 'scroll',
                  padding: '3rem 1rem 3rem 1rem',
                  boxShadow: 'rgb(0 0 0 / 5%) 0px 2px 4px 0px',
                },
              }
            }
          >
            <CloseIcon
              onClickCallbackShopMenu={() => showShopMenu(false)}
            />
            {!isSSR && (
            <div className="search__container--small">
              {searchSuggestions}
            </div>
             )}
            <ul className="shop__wrapper--small">
              {fields?.map((item, index) => (
                <li key={index}>
                  {renderMobileShopOptions(item.sys.contentType.sys.id || item?.contentfulContentType, item)}
                </li>
              ))}
            </ul>
          </OffCanvas>
        </Suspense>
      )}
    </StyledShopMenu>
  );
};

export default ShopMenu;
